import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainHeader = _resolveComponent("MainHeader")!
  const _component_NavbarThree = _resolveComponent("NavbarThree")!
  const _component_MainBanner = _resolveComponent("MainBanner")!
  const _component_WhatMakesUsDifferent = _resolveComponent("WhatMakesUsDifferent")!
  const _component_MarqueeText = _resolveComponent("MarqueeText")!
  const _component_OurSustainableApproach = _resolveComponent("OurSustainableApproach")!
  const _component_OurServices = _resolveComponent("OurServices")!
  const _component_PoweringDailyLife = _resolveComponent("PoweringDailyLife")!
  const _component_PricingPlans = _resolveComponent("PricingPlans")!
  const _component_TestOurService = _resolveComponent("TestOurService")!
  const _component_OurTestimonial = _resolveComponent("OurTestimonial")!
  const _component_EnjoySports = _resolveComponent("EnjoySports")!
  const _component_FanFact = _resolveComponent("FanFact")!
  const _component_CheckAvailability = _resolveComponent("CheckAvailability")!
  const _component_OurLatestArticles = _resolveComponent("OurLatestArticles")!
  const _component_PartnerLogo = _resolveComponent("PartnerLogo")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainHeader),
    _createVNode(_component_NavbarThree),
    _createVNode(_component_MainBanner),
    _createVNode(_component_WhatMakesUsDifferent),
    _createVNode(_component_MarqueeText),
    _createVNode(_component_OurSustainableApproach),
    _createVNode(_component_OurServices),
    _createVNode(_component_PoweringDailyLife),
    _createVNode(_component_PricingPlans),
    _createVNode(_component_TestOurService),
    _createVNode(_component_OurTestimonial),
    _createVNode(_component_EnjoySports),
    _createVNode(_component_FanFact),
    _createVNode(_component_CheckAvailability),
    _createVNode(_component_OurLatestArticles),
    _createVNode(_component_PartnerLogo),
    _createVNode(_component_MainFooter, {
      class: "bg-secondary bg-img",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
    }, null, 8, ["style"]),
    _createVNode(_component_CopyRight)
  ], 64))
}